// extracted by mini-css-extract-plugin
module.exports = {"container":"en_container__3vO_p","content":"en_content__2DIwt"};